import React from "react";
import T from "prop-types";
import { displayInt, displayFloat } from "LIB/formatters/number";
import { DataTable } from "MODULES/shared/components";
import { dollars } from "LIB/formatters/currency";
import _ from "lodash";

const renderRow = (r, pageActions) => (
  <tr key={r.buyer}>
    <td
      className="btn btn-link text-left"
      style={{ textTransform: "none", minWidth: 0 }}
      onClick={() => pageActions.setFilter("buyer_id", r.buyer_id)}
    >
      {r.buyer}
    </td>
    <td className="text-center">{dollars(r.total_purchases)}</td>
    <td className="text-center">{dollars(r.total_lot_purchases)}</td>
    <td className="text-center">{dollars(r.total_purchases_cancelled)}</td>
    <td className="text-center">
      {displayInt(r.incoming_quote_lines_entered)}
    </td>
    <td className="text-center">{displayInt(r.incoming_quotes_complete)}</td>
    <td className="text-center">
      {displayFloat(r.incoming_quote_lines_complete_percent)} %
    </td>
    <td className="text-center">{displayInt(r.po_line_items_count)}</td>
    <td className="text-center">{displayInt(r.pos_placed)}</td>
    <td className="text-center">{displayFloat(r.iq_to_po_conversion)} %</td>
    <td className="text-center">{displayInt(r.po_lines_shared)}</td>
    <td className="text-center">{displayFloat(r.po_lines_shared_percent)} %</td>
    <td className="text-center">{displayInt(r.po_line_cancellations)}</td>
    <td className="text-center">{displayFloat(r.po_cancellation_percent)} %</td>
  </tr>
);

export default function CurrentPurchasesTable({
  results,
  isLoading,
  pageActions
}) {
  const report = _.get(results[0], "current");

  return (
    <DataTable loading={isLoading} loadingRows={30}>
      <DataTable.Head>
        <th />
        <th>Total Purchased ($)</th>
        <th>Total Lot Purchased ($)</th>
        <th>Total Cancelled ($)</th>
        <th>#IQs Entered</th>
        <th>#IQs Completed</th>
        <th>#IQs Completed (%)</th>
        <th>#PO Line Items </th>
        <th>#PO&apos;s Placed</th>
        <th>IQ-PO Conversion (%)</th>
        <th>#Shared PO&apos;s Items</th>
        <th>#Shared PO Items (%)</th>
        <th># PO Cancellation Items</th>
        <th>PO Cancellation Items %</th>
      </DataTable.Head>
      <DataTable.Body>
        {report ? report.map(r => renderRow(r, pageActions)) : []}
      </DataTable.Body>
    </DataTable>
  );
}

CurrentPurchasesTable.propTypes = {
  isLoading: T.bool.isRequired,
  pageActions: T.shape({}).isRequired,
  results: T.arrayOf(T.shape({})).isRequired
};



// WEBPACK FOOTER //
// ./app/modules/PurchasesReport/Components/Search/CurrentPurchasesTable.jsx